import React from 'react';
import { Box, } from '@waglabs/box-next';
export const CardContent = (props) => (React.createElement(Box, Object.assign({ display: "flex", flexDirection: "column", justifyContent: "center", px: "48px" }, props)));
